import { redirectToExternalLogin } from 'helpers/loginRedirect.helper'
import api from '..'

const canView = () => {
  return api
    .get('/integrations/tenants/access')
    .then(({ data }) => data)
    .catch((err) => {
      redirectToExternalLogin()
      return Promise.reject(err)
    })
}

export default canView
